var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4615 0H2.69231C1.23077 0 0 1.23077 0 2.69231V17.3077C0 18.7692 1.23077 20 2.69231 20H26.4615C27.9231 20 29.1538 18.7692 29.1538 17.3077V2.69231C29.1538 1.23077 27.9231 0 26.4615 0ZM27.4615 17.3077C27.4615 17.8462 27 18.3077 26.4615 18.3077H2.69231C2.15385 18.3077 1.69231 17.8462 1.69231 17.3077V2.69231C1.69231 2.15385 2.15385 1.69231 2.69231 1.69231H26.4615C27 1.69231 27.4615 2.15385 27.4615 2.69231V17.3077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1541 4.76923H16.4618C16.0772 4.76923 15.7695 5.07692 15.7695 5.46153C15.7695 5.84615 16.0772 6.15384 16.4618 6.15384H24.1541C24.5388 6.15384 24.8465 5.84615 24.8465 5.46153C24.8465 5.07692 24.5388 4.76923 24.1541 4.76923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1541 13.8462H16.4618C16.0772 13.8462 15.7695 14.1539 15.7695 14.5385C15.7695 14.9231 16.0772 15.2308 16.4618 15.2308H24.1541C24.5388 15.2308 24.8465 14.9231 24.8465 14.5385C24.8465 14.1539 24.5388 13.8462 24.1541 13.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1541 8.69232H19.4618C19.0772 8.69232 18.7695 9.00001 18.7695 9.38463C18.7695 9.76924 19.0772 10.0769 19.4618 10.0769H24.1541C24.5388 10.0769 24.8465 9.76924 24.8465 9.38463C24.8465 9.00001 24.5388 8.69232 24.1541 8.69232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1541 11.3077H19.4618C19.0772 11.3077 18.7695 11.6154 18.7695 12C18.7695 12.3846 19.0772 12.6923 19.4618 12.6923H24.1541C24.5388 12.6923 24.8465 12.3846 24.8465 12C24.8465 11.5384 24.5388 11.3077 24.1541 11.3077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53906 10.3077C10.1544 10.3077 11.5391 8.99999 11.5391 7.30768C11.5391 5.69229 10.2314 4.30768 8.53906 4.30768C6.92368 4.30768 5.53906 5.61537 5.53906 7.30768C5.53906 8.92306 6.92368 10.3077 8.53906 10.3077ZM8.53906 5.76922C9.38522 5.76922 10.0775 6.46152 10.0775 7.30768C10.0775 8.15383 9.38522 8.84614 8.53906 8.84614C7.69291 8.84614 7.0006 8.15383 7.0006 7.30768C7.0006 6.46152 7.69291 5.76922 8.53906 5.76922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69171 10.8462H7.38401C5.76863 10.8462 4.46094 12.1539 4.46094 13.7692V15C4.46094 15.3846 4.76863 15.6923 5.15324 15.6923C5.53786 15.6923 5.84555 15.3846 5.84555 15V13.7692C5.84555 13 6.53786 12.3077 7.30709 12.3077H9.61478C10.384 12.3077 11.0763 13 11.0763 13.7692V15C11.0763 15.3846 11.384 15.6923 11.7686 15.6923C12.1532 15.6923 12.4609 15.3846 12.4609 15V13.7692C12.6148 12.1539 11.3071 10.8462 9.69171 10.8462Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1538,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNidIcon);
export default __webpack_public_path__ + "static/media/nid-icon.487f317c53c22ad8e57e7782be46766f.svg";
export { ForwardRef as ReactComponent };